import { Link } from "react-router-dom";
import { FaRegCircleDot } from "react-icons/fa6";
import { menuRoutes } from "../../../router/menu";
import { Badge, Button } from "rizzui";
import cn from "../../../utils/classNames";
import StockMovementModal from "./StockMovementModal";
import { useState } from "react";

interface AlertsProductProps {
    data: any;
    updateFilters: any;
    refetch: any;
    refetchAlerts: any;
}   

const AlertsProduct = ({ data, updateFilters, refetch, refetchAlerts }: AlertsProductProps) => {    

    // STATES

    const [productSelected, setProductSelected] = useState<any>(null);
    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);

    // RENDER

    return (
        <>
            {(data?.length > 0) && (
                <div className="mb-4">
                    <div className={`grid ${(data?.alertStock?.length > 0) ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1 md:grid-cols-1'} gap-4`}>
                        {data?.length > 0 && (
                            <div className="border border-[#f02b2b] rounded-md p-4">
                                <h3 className="text-sm font-semibold mb-2 text-[#f02b2b] flex items-center">
                                    <FaRegCircleDot className='me-2' />
                                    Alertas de stock
                                </h3>
                                <ul className="list-disc list-inside">
                                    {data?.slice(0, 4).map((product: any) => (
                                        <li key={product.id} className="text-sm text-[#f02b2b] flex justify-between items-center">
                                            <div>
                                                <Link
                                                    to={`${menuRoutes.products.path}/${product.id}/profile/${menuRoutes.products.profile.info}`}
                                                    className="font-semibold underline"
                                                >
                                                    {product.name}
                                                </Link>
                                                <span className="text-sm ms-3">
                                                    Stock actual: {product.currentStock} unidades ( Minimo: {product.minimumStock} )
                                                </span>
                                            </div>
                                            <div>
                                                 <Badge
                                                    color="secondary"
                                                    onClick={() => { 
                                                        setIsOpenFormDrawer(true) 
                                                        setProductSelected(product)
                                                    }}
                                                    className={cn(['text-xs cursor-pointer'])}
                                                >
                                                    Hacer pedido
                                                </Badge>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                {data?.expired?.length > 4 && (
                                    <p className="text-sm text-[#f02b2b] mt-2 cursor-pointer font-semibold underline" onClick={() => {
                                        updateFilters({ status: ['Vencida'] })
                                    }}>
                                        Ver más
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </div >
            )}
            <StockMovementModal 
                open={isOpenFormDrawer}
                onClose={() => {
                    setIsOpenFormDrawer(false);
                    setProductSelected(null);
                    refetchAlerts();
                    refetch();
                }}
                productSelected={productSelected}
            />
        </>
    )

}

export default AlertsProduct;
